import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { PURGE } from 'redux-persist'
import { getInvoices } from '../../../api/invoice/get-invoices'

/* Initial state of the slice */
const initialState = {
  isFetchingInvoices: false,
  invoices: [],
  fetchInvoicesError: null,
}

/* Handler for making service call to fetch inventory items */
export const fetchInvoices = createAsyncThunk(
  'invoice/fetchInvoices',
  async (args, { rejectWithValue }) => {
    try {
      const response = await getInvoices()
      return response?.data?.data
    } catch (exception) {
      return rejectWithValue(exception)
    }
  },
)

const invoiceSlice = createSlice({
  name: 'invoice',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchInvoices.pending, (state) => {
        state.isFetchingInvoices = true
        state.invoices = []
        state.fetchInvoicesError = null
      })
      .addCase(fetchInvoices.fulfilled, (state, action) => {
        state.isFetchingInvoices = false
        state.invoices = action.payload
      })
      .addCase(fetchInvoices.rejected, (state, action) => {
        state.isFetchingInvoices = false
        state.fetchInvoicesError = action.payload
      })
      /* Action which gets triggered
         when running persistor.purge() */
      .addCase(PURGE, () => {
        return initialState
      })
  },
})

export default invoiceSlice.reducer
